<button type="button" class="btn btn-primary" (click)="loginWithGoogle()"><fa-icon [icon]="['fab', 'google']"></fa-icon> Inloggen voor teams</button>
@if (errorMessage) {
  <p class="text-danger mt-2" role="alert">{{ errorMessage }}</p>
}
